import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

// style rules
import { Sizes, Colors } from "../../styles";

const Slide = ({
	slide,
}) => {
	const renderButton = () => {
		return (
			<a
				className="button"
				href={slide.button.url}
				target={slide.button.target}
			>
				{slide.button.title}
			</a>
		);
	};

	return (
		<SlideContainer>
			<ImageSide>
				<ImageContainer>
					<img src={slide.image} alt={`image for ${slide.title}`}/>
				</ImageContainer>
			</ImageSide>
			<TextSide>
				{slide.title && <Title>{slide.title}</Title>}
				{slide.text && <Text>{slide.text}</Text>}
				{slide.button && <ButtonContainer>{renderButton()}</ButtonContainer>}
			</TextSide>
		</SlideContainer>
	);
};

Slide.propTypes = {
	slide: PropTypes.object,
};

export default Slide;

const SlideContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.8rem;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		flex-direction: row;
	}
`;

const ImageSide = styled.div`
	max-width: 725px;
	flex: 1;
`;

const ImageContainer = styled.div`
	height: 0;
	overflow: hidden;
	padding-top: calc(454 / 725 * 100%);
	position: relative;
	width: 100%;
	border-radius: 20px;

	img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

const TextSide = styled.div`
	flex: 1;
	min-height: 319px;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		max-width: 514px;
		align-self: center;
		min-height: unset;
	}
`;

const Title = styled.h4`
	font-size: 3rem;
	line-height: 4rem;
	text-transform: uppercase;
	color: ${Colors.base.white};
`;

const Text = styled.p`
	color: ${Colors.base.white};
	padding-top: 2rem;
`;

const ButtonContainer = styled.div`
	padding-top: 4rem;
`;